import { render, staticRenderFns } from "./ItemListView.vue?vue&type=template&id=fab9d708&scoped=true&"
import script from "./ItemListView.vue?vue&type=script&lang=js&"
export * from "./ItemListView.vue?vue&type=script&lang=js&"
import style0 from "./ItemListView.vue?vue&type=style&index=0&id=fab9d708&prod&lang=scss&scoped=true&"
import style1 from "./ItemListView.vue?vue&type=style&index=1&id=fab9d708&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fab9d708",
  null
  
)

export default component.exports